import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import AvatarHome from "../../components/AvatarHome";

import Alert from "../../components/affiliates/Alert";
import { getAffiliateInfo } from "../../store/middleware";
import Contracts from "../../components/affiliates/Contracts";
import SalesLink from "../../components/affiliates/SalesLink";
import Disclosure from "../../components/affiliates/Disclosure";
import Productivity from "../../components/affiliates/Productivity";
import Transactions from "../../components/affiliates/Transactions";
import ModalTermUse from "../../components/affiliates/ModalTermUse";
import ModalTaxInformation from "../../components/affiliates/ModalTaxInformation";
import ModalProfilePicture from "../../components/affiliates/ModalProfilePicture";
import ModalPendingContract from "../../components/affiliates/ModalPendingContract";
import ModalPaymentInformation from "../../components/affiliates/ModalPaymentInformation";

function HomeAffiliate() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const { affiliateInfo } = useSelector((state) => state.affiliateReducer);

  const loadInfo = async () => {
    await dispatch(getAffiliateInfo(user?.id));
  };

  const [navBar, setNavBar] = useState(0);
  const [showProfilePicture, setShowProfilePicture] = useState(false);
  const [showTaxInformation, setShowTaxInformation] = useState(false);
  const [showPendingContract, setShowPendingContract] = useState(false);
  const [modalTermUseAffiliate, setModalTermUseAffiliate] = useState(false);
  const [showPaymentInformation, setShowPaymentInformation] = useState(false);

  useEffect(() => {
    affiliateInfo?.termsAcceptedsAt === null && setModalTermUseAffiliate(true);
  }, [affiliateInfo]);

  useEffect(() => {
    loadInfo();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="affiliate">
      <div className="boxInfo">
        <AvatarHome />

        <div className="contentAffiliate">
          <div className="wrapperAlert">
            {user?.picture === null && (
              <Alert
                title="ADD_PROFILE_PHOTO"
                titleButton="UPDATE_SCREEN"
                onClick={() => setShowProfilePicture(true)}
              />
            )}

            {affiliateInfo?.affiliateTaxInformations?.length === 0 && (
              <Alert
                title="ADD_TAX_INFORMATION"
                titleButton="UPDATE_SCREEN"
                onClick={() => setShowTaxInformation(true)}
              />
            )}
          </div>

          <div className="wrapperAlert">
            {affiliateInfo?.affiliatePaymentMethods?.length === 0 && user?.role !== "teacher" && (
              <Alert
                titleButton="UPDATE_SCREEN"
                title="ADD_PAYMENT_INFORMATION"
                onClick={() => setShowPaymentInformation(true)}
              />
            )}

            {affiliateInfo?.affiliateTaxInformations?.length > 0 &&
              affiliateInfo?.affiliateTaxInformations[0]?.wdocSignStatus !== "signed" && (
                <Alert
                  title="CONTRACT_PENDING"
                  titleButton="UPDATE_SCREEN"
                  onClick={() => setShowPendingContract(true)}
                />
              )}
          </div>

          <ModalTermUse showModal={modalTermUseAffiliate} setShowModal={setModalTermUseAffiliate} />
          <ModalTaxInformation showModal={showTaxInformation} setShowModal={setShowTaxInformation} />
          <ModalProfilePicture showModal={showProfilePicture} setShowModal={setShowProfilePicture} />
          <ModalPaymentInformation showModal={showPaymentInformation} setShowModal={setShowPaymentInformation} />
          <ModalPendingContract
            showModal={showPendingContract}
            setShowModal={setShowPendingContract}
            setShowTaxInformation={setShowTaxInformation}
          />

          <nav className="wrapperNavBar">
            <button className={`itemNavBar ${navBar === 0 && "active"}`} onClick={() => setNavBar(0)}>
              {t("SALES_LINK")}
            </button>
            <button className={`itemNavBar ${navBar === 1 && "active"}`} onClick={() => setNavBar(1)}>
              {t("PRODUCTIVITY")}
            </button>
            <button className={`itemNavBar ${navBar === 2 && "active"}`} onClick={() => setNavBar(2)}>
              {t("DISCLOSURE")}
            </button>
            <button className={`itemNavBar ${navBar === 3 && "active"}`} onClick={() => setNavBar(3)}>
              {t("TRANSACTIONS")}
            </button>
            {affiliateInfo?.affiliateTaxInformations?.length > 0 && (
              <button className={`itemNavBar ${navBar === 4 && "active"}`} onClick={() => setNavBar(4)}>
                {t("CONTRACTS")}
              </button>
            )}
          </nav>

          {navBar === 0 && <SalesLink />}
          {navBar === 1 && <Productivity setNavBar={setNavBar} />}
          {navBar === 2 && <Disclosure />}
          {navBar === 3 && <Transactions />}
          {navBar === 4 && <Contracts setShowTaxInformation={setShowTaxInformation} />}
        </div>
      </div>
    </div>
  );
}

export default HomeAffiliate;
